export default {
  User: 8,
  DestinationDelivery: 9,
  DestinationPackage: 10,
  OriginPackage: 11,
  WareHouse: 12,
  OriginTransportation: 13,
  OriginPackageTransportation: 14,
  DestinationPackageDelivery: 15,
  Company: 16,
  Sale: 17,
  Customer: 18,
  CustomerBill: 19,
  CompanyBill: 20,
  CompanyFormula: 21,
  CompanyWeightFormula: 22,
  CompanyVolumeFormula: 23,
  CustomerFormula: 24,
  CustomerWeightFormula: 25,
  CustomerVolumeFormula: 26,
  OriginPackageImage: 27,
  SaleImage: 28,
  CustomerImage: 29,
  CompanyImage: 30,
  OriginPackageService: 31,
  CustomerRoute: 32,
  CompanyRoute: 33,
  DestinationPackageService: 34,
  DestinationPackageImage: 35,
  CustomerBillItem: 36,
  CompanyBillItem: 37,
  CustomerBillImage: 38,
  CompanyBillImage: 39,
  CustomerLine: 40,
  CompanyLine: 41,
  OriginPackageRate: 42,
  ManagerCompany: 43,
  Manager: 44,
  CompanyBannerImage: 45,
  CompanyNews: 46,
  RequestSignup: 47,
  CompanyPolicy: 48,
  CompanySale: 49,
};
